// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTableHeaderScrollbar_wrapper__3CcVJ","scrollButton":"DataTableHeaderScrollbar_scrollButton__3SWJ8"};